import { uploadFileStatusSelector } from "./../redux/selector";
import { toast } from "react-toastify";
import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  uploadFileStart,
  uploadFileSuccess,
  uploadFileFailed,
} from "../redux/uploadFile";

import { postFileApi } from "core/http/service/personnelInformation";
import {
  updateCurrentData,
  updateFormEditEducationInformation,
} from "../redux/formEditEducationInformation";
import { get } from "lodash";
import {
  formEditBasicInformationDataSelector,
  formEditEducationInformationDataSelector,
} from "../redux/selector";
import {
  updateBasicInformationCurrentData,
  updateFormEditBasicInformation,
} from "../redux/formEditBasicInformation";
import { ReduxStateType } from "redux-store/types";
import { changeFormErrors } from "redux-store/static/redux/validation";

const actionTypeToSelectorMap = {
  [updateFormEditBasicInformation.type]: formEditBasicInformationDataSelector,
  [updateFormEditEducationInformation.type]:
    formEditEducationInformationDataSelector,
};

const actionUpdateCurrentData = {
  [updateFormEditBasicInformation.type]: updateBasicInformationCurrentData.type,
  [updateFormEditEducationInformation.type]: updateCurrentData.type,
};

function* replaceFilesWithUrls(data: any) {
  const { callback, actionType, keyForm } = data.payload;
  const selector = actionTypeToSelectorMap[actionType];
  const actionUpdate = actionUpdateCurrentData[actionType];
  let obj = data.payload.obj;
  const promises = [];

  function* recursiveReplace(obj, keyForm, currentPath = "") {
    for (const key in obj) {
      if (key.includes("_files")) {
        const listFiles = (obj[key] ?? []).filter(Boolean);
        if (listFiles.length === 0) {
          continue;
        }
        const fieldNameFiles = `${currentPath}${key}`.replace("_files", "");
        const valueFiles = get(obj, key.replace("_files", "")) ?? [];
        for (let i = 0; i < obj[key].length; i++) {
          const promise = call(function* () {
            const fieldName = `${fieldNameFiles}.${i + valueFiles.length}`;

            const currentfieldName = `${currentPath}${key}.${i + valueFiles.length}`;
            const fieldNameFileContent = currentfieldName.replace(
              "_files",
              "_file_contents"
            );

            try {
              const url = yield call(postFileApi, obj[key][i]);

              yield put({
                type: actionType,
                payload: {
                  [fieldName]: url,
                  [currentfieldName]: null,
                  [fieldNameFileContent]: null,
                },
              });
            } catch (error) {
              const fileImageName = error?.response?.data?.dataInput;
              toast.error(
                `File ${fileImageName.split("file: ")[1]} tải lên không thành công, vui lòng thử lại`
              );
              yield put({
                type: uploadFileFailed.type,
                payload: error,
              });

              yield put({
                type: actionType,
                payload: {
                  [fieldName]: get(
                    obj,
                    `${key.replace("_files", "_file_contents")}.${i}`
                  ),
                },
              });

              yield put({
                type: changeFormErrors.type,
                payload: {
                  key: keyForm,
                  payload: (prevState) => ({
                    isScrollToFirstError: true,
                    formErrors: {
                      ...prevState.formErrors,
                      [fieldNameFiles]:
                        "File upload sai định dạng hoặc vượt quá kích thước 3MB",
                    },
                  }),
                },
              });
            }
          });
          promises.push(promise);
        }
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        yield* recursiveReplace(obj[key], keyForm, `${currentPath}${key}.`);
      }
    }
  }

  yield* recursiveReplace(obj, keyForm);

  try {
    yield all(promises);

    const changedData = yield select(selector);

    yield put({
      type: actionUpdate,
      payload: { ...changedData, files_file_contents: [], files_files: [] }, // reset các file đã upload
    });
    const uploadFileStatusSelectorData = yield select(uploadFileStatusSelector);

    if (callback && uploadFileStatusSelectorData !== ReduxStateType.ERROR) {
      yield put({
        type: uploadFileSuccess.type,
      });
      callback({ ...changedData, files_file_contents: [], files_files: [] });
    }
  } catch (error) {}
}

function* watchUploadFile() {
  yield takeLatest(uploadFileStart.type, replaceFilesWithUrls);
}

export default function* uploadFileSaga() {
  yield all([watchUploadFile()]);
}
